import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { QUERY_KEYS } from '../../config/queryClient';
import { useBrand } from '../../context/BrandContext';

const useDashboardKeywordsCloud = ({ timePeriod = '7d', limit = 100, tags = [], competitor = '', keyword = '', customDateRange = null, enabled = true } = {}) => {
  const { brandVersion } = useBrand();

  const getQueryParams = () => {
    const params = new URLSearchParams();
    if (timePeriod && timePeriod !== 'all') {
      params.append('timePeriod', timePeriod);
    }
    const toDateStr = (value) => {
      if (!value) return '';
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };
    if (customDateRange?.startDate) params.append('startDate', toDateStr(customDateRange.startDate));
    if (customDateRange?.endDate) params.append('endDate', toDateStr(customDateRange.endDate));
    if (customDateRange?.dateType) params.append('dateType', customDateRange.dateType);
    params.append('limit', limit);
    if (tags && tags.length > 0) {
      params.append('tags', tags.join(','));
    }
    if (competitor) {
      params.append('competitor', competitor);
    }
    if (keyword) {
      params.append('keyword', keyword);
    }
    return params.toString();
  };

  const keywordsQuery = useQuery({
    queryKey: [QUERY_KEYS.articles, 'dashboard-keywords-cloud', brandVersion, timePeriod, customDateRange, { limit, tags, competitor, keyword }],
    queryFn: async () => {
      const queryString = getQueryParams();
      console.log('🔑 Fetching keywords cloud:', queryString);
      const response = await api.get(`/dashboard/keywords-cloud?${queryString}`);
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    enabled,
  });

  return {
    keywordsCloud: keywordsQuery.data || [],
    loading: keywordsQuery.isLoading,
    isFetching: keywordsQuery.isFetching,
    error: keywordsQuery.error,
  };
};

export default useDashboardKeywordsCloud;
